import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomeOne from "./Pages/HomeOne/HomeOne/HomeOne";
import HomeTwo from "./Pages/HomeTwo/HomeTwo/HomeTwo";
import HomeThree from "./Pages/HomeThree/HomeThree/HomeThree";
import About from "./Pages/About/About";
import ScrollTop from "./Pages/ScrollTop/ScrollTop";
import Services from "./Pages/Services/Services";
import ServicesDetails from "./Pages/Services/ServicesDetails";
import CMRSolutions from "./Pages/Services/CMRServices";
import DataManagementServices from "./Pages/Services/DataManagementServices";
import ContentMarketing from "./Pages/Services/SoftwareDevelopmentServices";
import DigitalMarketing from "./Pages/Services/DigitalMarketing";
import SeoMarketing from "./Pages/Services/MobileDevelopmentServices";
import UiDesign from "./Pages/Services/WebsiteDevelopmentServices";
import Projects from "./Pages/Projects/Projects";
import ProjectsDetails from "./Pages/Projects/ProjectsDetails";
import Pricing from "./Pages/Pricing/Pricing";
import Team from "./Pages/Team/Team";
import Testimonial from "./Pages/Testimonial/Testimonial";
import Error from "./Pages/Error/Error";
import Blog from "./Pages/Blog/Blog";
import BlogDetails from "./Pages/Blog/BlogDetails";
import Contact from "./Pages/Contact/Contact";
import WOW from 'wowjs';

function App() {

  useEffect(() => {
    new WOW.WOW({
      mobile: false
    }).init();
  }, []);

  return (
    <>
      <Router><Routes>
        <Route path="/" element={<HomeOne />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services-details" element={<ServicesDetails />} />
        <Route path="/software-development-services" element={<ContentMarketing />} />
        <Route path="/digital-marketing-services" element={<DigitalMarketing />} />
        <Route path="/mobile-development-services" element={<SeoMarketing />} />
        <Route path="/website-development-services" element={<UiDesign />} />
        <Route path="/data-management-services" element={<DataManagementServices />} />
        <Route path="/crm-solutions" element={<CMRSolutions />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects-details" element={<ProjectsDetails />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/team" element={<Team />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/error" element={<Error />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-details" element={<BlogDetails />} />
        <Route path="/contact" element={<Contact />} />
      </Routes></Router>
      <ScrollTop />

    </>
  )
}

// const servicesData = [

//   { id: 5, title: 'Data Management Services', slug: '/data-management-services' },
//   { id: 6, title: 'Customer Relationship Management (CRM) Solutions', slug: '/crm-solutions' },

// ];

export default App
